import { FC, useState } from 'react';
import Buttons from '@/components/Buttons';
import CollapsibleArea from '@/components/CollapsibleArea';
import { useIsMobile } from '@/hooks';
import Modal from '@/components/Modal';
import Play from '@/components/Icons/Play';
import Image from 'next/image';

import Retainer from './video-covers/retainer.jpg';
import Engage from './video-covers/engage.jpg';
import Documents from './video-covers/documents.jpg';
import PayStubs from './video-covers/pay-stubs.jpg';
import RetainerMobile from './video-covers/retainer-mobile.jpg';
import EngageMobile from './video-covers/engage-mobile.jpg';
import DocumentsMobile from './video-covers/documents-mobile.jpg';
import PayStubsMobile from './video-covers/pay-stubs-mobile.jpg';

import s from './Home.module.scss';

const videos = {
  desktop: [
    {
      embed: 'https://www.loom.com/embed/4401417140f241b1a0949194869a8046?sid=16c79f52-c5a0-4d08-bc87-05ff2695450f',
      id: 'retainer',
      image: Retainer,
      title: 'How to sign a retainer agreement?',
    },
    {
      embed: 'https://www.loom.com/embed/8f03a34037ef4fbbb400e68803128165?sid=c9444ee9-ebc8-4383-82d4-dc9c3222e4ad',
      id: 'engage',
      image: Engage,
      title: 'How to engage with your Law Firm regarding your case?',
    },
    {
      embed: 'https://www.loom.com/embed/ee2d292c4600418eaf9bdadb3c59d5da?sid=37c093da-78f4-462d-be05-a6b382a94af9',
      id: 'documents',
      image: Documents,
      title: 'How to Upload Documents for review?',
    },
    {
      embed: 'https://www.loom.com/embed/5a40e348fd744f13841b199192bd7f24?sid=b50b67a6-8598-4d95-aa67-5a88211f2f96',
      id: 'pay-stubs',
      image: PayStubs,
      title: 'How to upload Pay Stubs?',
    },
  ],
  mobile: [
    {
      embed: 'https://www.loom.com/embed/2cf0ad4339ed4f62867a3f99c912f040?sid=3dc67e8e-1d5f-4713-9f00-0c659f5871c0',
      id: 'retainer-mobile',
      image: RetainerMobile,
      title: 'How to sign a retainer agreement on your mobile?',
    },
    {
      embed: 'https://www.loom.com/embed/4806afc37f704d219d100532b710929c?sid=7d3cf642-03db-4192-b353-7f59d2d20433',
      id: 'engage-mobile',
      image: EngageMobile,
      title: 'How to engage with your Law Firm on your mobile?',
    },
    {
      embed: 'https://www.loom.com/embed/702a04b19d1045a7b194a24664b373d9?sid=c3ef7458-2f37-4563-befe-5231345335ad',
      id: 'documents-mobile',
      image: DocumentsMobile,
      title: 'How to upload documents on your mobile?',
    },
    {
      embed: 'https://www.loom.com/embed/fcd2f612d37943c79acd4efdc5c4649d?sid=583d69cf-8766-4916-bd57-85e365458f57',
      id: 'pay-stubs-mobile',
      image: PayStubsMobile,
      title: 'How to upload Pay Stubs on your mobile?',
    },
  ],
};

const TrainingVideos: FC = () => {
  const [openModal, setOpenModal] = useState<string | undefined>(undefined);
  const isMobile = useIsMobile();

  return (
    <>
      <CollapsibleArea
        className={s.videos}
        title="Do you need help getting around?"
        description="Watch tutorial videos to get started"
      >
        <ul className={s.videosList}>
          {videos[isMobile ? 'mobile' : 'desktop'].map(video => (
            <li key={video.title}>
              {openModal === video.id && (
                <Modal onClose={() => setOpenModal(undefined)} title={video.title}>
                  <iframe
                    src={video.embed}
                    allowFullScreen
                    style={{
                      border: 'none',
                      display: 'block',
                      height: 400,
                      width: '100%',
                    }}
                  />
                </Modal>
              )}
              <Buttons isWrapper onClick={() => setOpenModal(video.id)} className={s.videosListButton}>
                <div className={s.videosListButtonCover}>
                  <Image
                    src={video.image}
                    alt={video.title}
                    width={(isMobile ? 90 : 160) * 4}
                    height={isMobile ? 160 : 90 * 4}
                    className={s.videosListButtonCoverImage}
                  />
                  <div>
                    <Play weight="fill" size={isMobile ? 16 : 24} color="var(--color-gray-100)" />
                  </div>
                </div>
                <div className={s.videosListButtonText}>
                  <p className="body-sm-bold">{video.title}</p>
                  <p className="caption">Click to play video</p>
                </div>
              </Buttons>
            </li>
          ))}
        </ul>
      </CollapsibleArea>
    </>
  );
};

export default TrainingVideos;
